import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pt-5" }
const _hoisted_2 = { class: "text-end mt-15" }

import { ref, reactive } from "vue";
import { FormInstance } from "element-plus";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { useI18n } from "vue-i18n";
import ToolServices from "../services/ToolServices";


export default /*#__PURE__*/_defineComponent({
  __name: 'CheaterIpCreate',
  emits: ["eventSubmit"],
  setup(__props, { expose: __expose, emit: emits }) {

const isLoading = ref(false);
const createModalRef = ref(false);
const edit = ref(false);
const formRef = ref<FormInstance>();
const formData = ref<any>({
  ip: "",
  note: "",
});
const formRule = reactive<any>({
  ip: [{ required: true, message: "Please input IP", trigger: "blur" }],
  note: [
    { required: true, message: "Please input description", trigger: "blur" },
  ],
});

const addCheaterIp = async (formEl: FormInstance | undefined) => {
  isLoading.value = true;
  if (!formEl) return;
  await formEl?.validate((valid) => {
    if (valid) {
      submit();
    } else {
      return false;
    }
  });
  isLoading.value = false;
};

const submit = async () => {
  isLoading.value = true;
  try {
    if (edit.value == false) {
      await ToolServices.addCheaterIp({
        ip: formData.value.ip,
        note: formData.value.note,
      });
    } else {
      await ToolServices.updateCheaterIp(formData.value.id, {
        ip: formData.value.ip,
        note: formData.value.note,
        enable: formData.value.enable,
      });
    }
    MsgPrompt.success("Success");
    emits("eventSubmit");
    close();
  } catch (error) {
    console.log(error);
    MsgPrompt.error(error);
  }
  isLoading.value = false;
};

const show = (item?: any) => {
  createModalRef.value = true;
  if (item) {
    formData.value.id = item.id;
    formData.value.enable = item.enable;
    formData.value.ip = item.ip;
    formData.value.note = item.note;
    edit.value = true;
  }
};

const clear = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.resetFields();
};

const close = () => {
  edit.value = false;
  clear(formRef.value);
  createModalRef.value = false;
};



__expose({ show });

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: edit.value == false ? _ctx.$t('action.addCheaterIp') : 'Edit Cheater IP',
    width: "500",
    "align-center": "",
    modelValue: createModalRef.value,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((createModalRef).value = $event)),
    "before-close": close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          model: formData.value,
          rules: formRule,
          ref_key: "formRef",
          ref: formRef,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "IP",
              prop: "ip"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.ip,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.ip) = $event)),
                  placeholder: "IP",
                  clearable: "",
                  disable: isLoading.value
                }, null, 8, ["modelValue", "disable"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "Note",
              prop: "note",
              class: "mt-5"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.note,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.note) = $event)),
                  placeholder: "Note",
                  clearable: "",
                  disable: isLoading.value
                }, null, 8, ["modelValue", "disable"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_button, {
                type: "danger",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (createModalRef.value = false), ["prevent"])),
                disable: isLoading.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("action.close")), 1)
                ]),
                _: 1
              }, 8, ["disable"]),
              _createVNode(_component_el_button, {
                type: "success",
                disable: isLoading.value,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (addCheaterIp(formRef.value)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("action.submit")), 1)
                ]),
                _: 1
              }, 8, ["disable"])
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})